import * as React from 'react';

const RedIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='20'
    viewBox='0 0 16 20'
    fill='none'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16 5.82843L16 17C16 18.6569 14.6569 20 13 20L3 20C1.34315 20 -8.15517e-07 18.6569 -7.43094e-07 17L-1.31134e-07 3C-5.87108e-08 1.34315 1.34315 -6.40671e-07 3 -5.68248e-07L10.1716 -2.54769e-07C10.9672 -2.1999e-07 11.7303 0.316069 12.2929 0.878679L15.1213 3.70711C15.6839 4.26972 16 5.03278 16 5.82843ZM14 17L14 5.82843C14 5.56321 13.8946 5.30886 13.7071 5.12132L10.8787 2.29289C10.6911 2.10536 10.4368 2 10.1716 2L3 2C2.44771 2 2 2.44771 2 3L2 17C2 17.5523 2.44771 18 3 18L13 18C13.5523 18 14 17.5523 14 17ZM12 12.5L12 16C12 16.5523 11.5523 17 11 17C10.4477 17 10 16.5523 10 16L10 12.5C10 11.9477 10.4477 11.5 11 11.5C11.5523 11.5 12 11.9477 12 12.5ZM11 8C11.5523 8 12 8.44772 12 9L12 10C12 10.5523 11.5523 11 11 11C10.4477 11 10 10.5523 10 10L10 9C10 8.44772 10.4477 8 11 8ZM8 14C8.55228 14 9 14.4477 9 15L9 16C9 16.5523 8.55228 17 8 17C7.44772 17 7 16.5523 7 16L7 15C7 14.4477 7.44772 14 8 14ZM8 8C8.55228 8 9 8.44772 9 9L9 12.5C9 13.0523 8.55228 13.5 8 13.5C7.44772 13.5 7 13.0523 7 12.5L7 9C7 8.44772 7.44772 8 8 8ZM5 8C5.55229 8 6 8.44772 6 9L6 10C6 10.5523 5.55229 11 5 11C4.44772 11 4 10.5523 4 10L4 9C4 8.44772 4.44772 8 5 8ZM5 11.5C5.55229 11.5 6 11.9477 6 12.5L6 16C6 16.5523 5.55229 17 5 17C4.44772 17 4 16.5523 4 16L4 12.5C4 11.9477 4.44772 11.5 5 11.5Z'
      fill='#200000'
    />
  </svg>
);

export default RedIcon;
